import AthleteManager from './AthleteManager';

export default AthleteManager;
